import { render } from "./ViewManufacturers.vue?vue&type=template&id=615d908e"
import script from "./ViewManufacturers.vue?vue&type=script&lang=js"
export * from "./ViewManufacturers.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__